import { isRgba } from '../color.ts';
import { migrateBoatDocument } from './migrate.ts';
import type { BoatDocument } from './types.ts';

const NUMBER_FIELDS = [
  'lengthM',
  'beamM',
  'draftM',
  'planingSpeedKmh',
  'turnM',
  'accelM',
  'brakeM',
] as const;

const COLOR_FIELDS = ['hull', 'deck', 'accent'] as const;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/**
 * A shared boat file must already be a boat: version plus the hull numbers and colours.
 * `migrateBoatDocument` still fills a missing field on a real boat file; this rejects a
 * document that only happens to have `"version": 1`.
 */
export function importBoatDocument(json: string): BoatDocument | null {
  let value: unknown;

  try {
    value = JSON.parse(json) as unknown;
  } catch {
    return null;
  }

  if (!isRecord(value) || typeof value.version !== 'number' || !Number.isFinite(value.version)) {
    return null;
  }

  if (value.name !== undefined && typeof value.name !== 'string') {
    return null;
  }

  for (const key of NUMBER_FIELDS) {
    const number = value[key];

    if (typeof number !== 'number' || !Number.isFinite(number)) {
      return null;
    }
  }

  for (const key of COLOR_FIELDS) {
    if (!isRgba(value[key])) {
      return null;
    }
  }

  return migrateBoatDocument(value);
}
